/**
 * The rules a paired state view is made by (decision 030), apart from anything
 * that renders.
 */

import type { EntityRow } from '../../schema'

/** The package a qualified name is declared in: everything before its last segment. */
export function packageOf(qualifiedName: string): string {
  return qualifiedName.split('::').slice(0, -1).join('::')
}

/** A state that can be a view's machine: a def declared in no other state. */
export function isMachine(row: EntityRow): boolean {
  return row.is_definition !== false && !row.owner
}
